import axios, { AxiosInstance } from 'axios';
import { configEnv } from '@/shared/config-env';
import * as Sentry from '@sentry/vue';

export let axiosBitrix: AxiosInstance = axios;

if (axios.create) {
  axiosBitrix = axios.create({
    baseURL: configEnv.BITRIX_URL,
    headers: {
      'Version': 1,
      // 'x-source-lp': 'personalAreaClientLP',
    },
  });

  let requestsCount = 1;
  axiosBitrix.interceptors.request.use(
    request => {
      requestsCount += 1;
      return new Promise(resolve => {
        setTimeout(() => {
          resolve(request);
        }, requestsCount * 200);
      });
    },
    error => error,
  );

  axiosBitrix.interceptors.response.use(
    response => {
      requestsCount -= 1;
      return response;
    },
    error => {
      if (axios.isCancel(error)) {
        return false;
      }
      if (error.status === 0 || error.message.includes('Network')) {
        Sentry.captureMessage('Ошибка со статусом 0.');
      }
      return Promise.reject(error);
    },
  );
}
